// extracted by mini-css-extract-plugin
export var container = "_3j-1";
export var editor = "_3j-2";
export var resizable = "_3j-3";
export var wrapper = "_3j-0";